
export enum ESideKickRequestStatus {
  pending = 'pending',
  completed = 'completed'
}